export default {"src":"/newStatic/_next/static/media/why_bitbns_illustration.aaf02169.svg","height":145,"width":173};